import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AwsCognitoService {
  constructor(private http: HttpClient) {}

  public getTokenDetailsFromCognito(callbackCode: string): Observable<any> {
    const details = {
      grant_type: 'authorization_code',
      code: callbackCode,
      scope: 'openid+email',
      redirect_uri: environment.envVar.redirectURL,
      client_id: environment.envVar.clientId
    };
    // Use 'keyof typeof details' to restrict keys to those in the 'details' object.
    const formBody = Object.keys(details)
      .map((key) => {
        // Type assertion to ensure that 'key' is one of the keys of 'details'.
        const typedKey = key as keyof typeof details;
        return `${encodeURIComponent(typedKey)}=${encodeURIComponent(details[typedKey])}`;
      })
      .join('&');

    const cognitoTokenURL = `${environment.envVar.cognitoDomain}/oauth2/token`;

    return this.http.post<any>(cognitoTokenURL, formBody, {
      responseType: 'json',
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    });
  }

  public logoutUserFromCognito(ssoLogin: string, ssoLogoutUrl: string) {
    if (ssoLogoutUrl) {
      window.location.href = `${environment.envVar.cognitoDomain}/logout?client_id=${environment.envVar.clientId}&logout_uri=${ssoLogoutUrl}`;
    } else {
      if (ssoLogin === 'OIDC') {
        const logoutUrl = `${environment.envVar.cognitoDomain}/logout?client_id=${environment.envVar.clientId}&logout_uri=${environment.envVar.oidcLogout}`;
        window.location.href = logoutUrl;
      } else {
      const baseUrl = new URL(environment.envVar.redirectURL).origin;
      const logoutUri = `${baseUrl}/login`;
        const logoutUrl = `${environment.envVar.cognitoDomain}/logout?client_id=${environment.envVar.clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
        window.location.href = logoutUrl;
      }
    }
    // return this.http.get<any>(environment.logout);
  }
}
